import { InteractsWithDOM } from '@scripts/core/InteractsWithDOM.js';

export default class VideoSticky extends InteractsWithDOM {

    /**
     * @type {boolean}
     * @private
     */
    _open = false;

    /**
     * @return {boolean}
     */
    get open () {
        return this._open;
    }

    /**
     * @param {boolean} value
     */
    set open (value) {
        if (value)
            this.handleOpen();
        else
            this.handleClose();

        this._open = value;
    }

    constructor (domElm) {
        super(domElm);

        this.retrieveElements();
        this.addListeners();
        this.init();
    }

    retrieveElements () {
        this.video = this.domElm.querySelector('video');
        this.cta = this.domElm.querySelector('.video-sticky__cta');
        this.closeBtn = this.domElm.querySelector('.video-sticky__close-cta');
    }

    addListeners () {
        this.cta.addEventListener('click', () => this.open = !this.open);
        this.closeBtn.addEventListener('click', () => this.open = !this.open);
    }

    init () {

    }

    handleClose () {
        this.domElm.classList.remove('open');
    }

    handleOpen () {
        this.domElm.classList.add('open');
    }
}
